import React from 'react';
import PropTypes from 'prop-types';
import {
  FDBodyText, FDBox, FDClickableText, FDLabelText, FDStack, FDTitleText,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { dataAttrs } from 'Helpers/Testing';

const RoutingHistorySection = ({ label, collection }) => {
  const { displayErrorMessage } = useSnackbarContext();
  const { selectThread } = useMessagesContext();

  const handleOriginalThreadClick = async (rel) => {
    try {
      const [threadResource] = await rel.link('related').get();
      selectThread(threadResource);
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to go to original thread');
    }
  };

  return (
    <FDStack direction={'column'} spacing={2}>
      <FDTitleText value={label} />
      <FDStack direction={'column'} spacing={3}>
        {
          collection?.resources().list().map((item) => {
            return (
              <FDStack direction={'column'} spacing={1} {...dataAttrs('routing-history-item')}>
                <FDLabelText value={item.attr('dateText')} {...dataAttrs('routing-history-item-date')} />
                <FDBox>
                  <FDBodyText value={item.attr('description')} {...dataAttrs('routing-history-item-description')} />
                  {
                    item.withRelationship(
                      fr.relationships.originalThread.name,
                      (rel) => {
                        return (
                          <FDClickableText
                            label={rel.meta('prompt')}
                            onClick={() => handleOriginalThreadClick(rel)}
                            appearance={'standalone'}
                            {...dataAttrs('routing-history-item-original-thread-clickable-text')}
                          />
                        );
                      },
                      () => null,
                    )
                  }
                </FDBox>
              </FDStack>
            );
          })
        }
      </FDStack>
    </FDStack>
  );
};

RoutingHistorySection.defaultProps = {
  label: undefined,
};

RoutingHistorySection.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
  label: PropTypes.string,
};

export default RoutingHistorySection;
